import { render } from "./BadgeListComponent.vue?vue&type=template&id=00fe7e80"
import script from "./BadgeListComponent.vue?vue&type=script&lang=js"
export * from "./BadgeListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__